import { classNames } from '@/util/tailwindHelpers'
import PointsDisplay from '@/features/arcade/components/ArcadeLeaderboard/PointsDisplay'
import React from 'react'
import Tooltip from '@/components/Tooltip'
import { ItemDetail } from '../BaseDetail'

type PointsStatus = 'eligible' | 'ineligible' | 'offSeason'

type Props = {
  className?: string
  item: ItemDetail
}

export default function Points({ item, className }: Props) {
  const { arcade, points, arcade_enabled } = item

  if (!arcade_enabled) return null

  let status: PointsStatus
  if (points === null) {
    status = 'ineligible'
  } else if (arcade.season.season_status !== 'current') {
    status = 'offSeason'
  } else {
    status = 'eligible'
  }

  const isInSeason = status !== 'offSeason'
  const showSuffix = status === 'eligible'

  let value: string | number
  switch (status) {
    case 'eligible':
      value = points
      break
    case 'ineligible':
      value = '–'
      break
    case 'offSeason':
      value = 'TBD'
      break
  }

  let message: string =
    'This item is eligible for conversion into Arcade points.'
  if (status === 'ineligible') {
    message = 'This item can not be converted to Arcade points.'
  } else if (status === 'offSeason') {
    message = 'New point values will be revealed next season.'
  }

  return (
    <div className={classNames('@container', className)}>
      <Tooltip
        trigger={() => (
          <PointsDisplay
            value={value}
            className={classNames('max-w-max', {
              'text-gray-300': status !== 'eligible'
            })}
            iconClassName={classNames({
              'text-white': !isInSeason
            })}
            showSuffix={showSuffix}
          />
        )}
      >
        {message}
      </Tooltip>
    </div>
  )
}
